var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQualityPromise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3645 15.1565H25.1734L22.9441 17.0325V2.76927H43.3942V15.1268L43.3645 15.1565ZM21.0715 0H19.9717V1.69729V23.9408L26.0948 18.2831H46.3666V0H21.0715Z",
    fill: "#BDCCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.971 36.1793C30.5018 36.1793 26.0432 40.5566 25.8945 46.0058H46.0771C45.9285 40.5566 41.4699 36.1793 36.0007 36.1793H35.971Z",
    fill: "#0AE8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0764 36.0469C4.60722 36.0469 0.14862 40.4241 0 45.8733H20.1826C20.034 40.4241 15.5754 36.0469 10.1062 36.0469H10.0764Z",
    fill: "#006BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4485 34.8398C13.1237 34.8398 15.2936 32.666 15.2936 29.9861C15.2936 27.3062 13.1237 25.1324 10.4485 25.1324C7.77337 25.1324 5.60352 27.3062 5.60352 29.9861C5.60352 32.666 7.77337 34.8398 10.4485 34.8398Z",
    fill: "#006BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1191 29.9861C31.1191 32.666 33.289 34.8398 35.9642 34.8398C38.6393 34.8398 40.8092 32.666 40.8092 29.9861C40.8092 27.3062 38.6393 25.1324 35.9642 25.1324C33.289 25.1324 31.1191 27.3062 31.1191 29.9861Z",
    fill: "#0AE8F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityPromise);
export default __webpack_public_path__ + "static/media/quality_promise.c08e8605a25039a2fc964ebcf34ebe59.svg";
export { ForwardRef as ReactComponent };